export const formatDateTable = (dateString) => {
  if (!dateString) return '';
  return dateString.slice(0, 10);
};

export const formatFoundationVintage = (vintage) => {
  if (vintage === undefined || vintage === null) {
    return vintage;
  }

  const digits = String(vintage).replace(/\D/g, '');
  const normalizedVintage = digits.length === 3 ? digits.padStart(4, '0') : digits;

  if (normalizedVintage.length === 4 && /^\d{4}$/.test(normalizedVintage)) {
    const monthCode = normalizedVintage.substring(0, 2);
    const month = parseInt(monthCode, 10);
    const year = `20${normalizedVintage.substring(2, 4)}`;

    if (monthCode === '06') {
      return `1H ${year}`;
    }

    if (monthCode === '12') {
      return `2H ${year}`;
    }

    if (month >= 1 && month <= 6) {
      return `1H ${year}`;
    }

    if (month >= 7 && month <= 12) {
      return `2H ${year}`;
    }
  }

  return vintage;
};

export const getFundType = (fundCode, baseFundCode, fundFamilyName) => {
  const code = baseFundCode.toUpperCase();
  
  if (code.includes('FOUN') || fundFamilyName === 'Foundation Fund') {
    return 'Foundation Funds';
  }
  
  if (code.startsWith('FF') || fundFamilyName === 'Focused Fund') {
    return 'Focused Funds';
  }
  
  if (code && !code.includes('FOUN') && !code.startsWith('FF')) {
    return 'Alumni Funds';
  }
  
  return 'Other';
};

const FUND_TYPE_MAP = {
  AF: 'Alumni Fund',
  CF: 'Alumni Fund',
  FF: 'Focused Fund',
  FOUN: 'Foundation Fund',
  FOUND: 'Foundation Fund',
};

export const mapFundTypeToFullName = (fundType) => {
  const type = fundType?.toUpperCase();
  return FUND_TYPE_MAP[type] || 'Other';
};

const parseDateSortValue = (value) => {
  if (!value) {
    return null;
  }

  const timestamp = new Date(value).getTime();
  return Number.isNaN(timestamp) ? null : timestamp;
};

export const sortData = (data, sortField, sortOrder) => {
  const sorted = [...data].sort((a, b) => {
    let aValue = a[sortField];
    let bValue = b[sortField];
    
    const isDateField = sortField.includes('Close')
      || sortField.includes('closeDate')
      || sortField.includes('initialCloseDate')
      || sortField.includes('finalCloseDate')
      || sortField.includes('openDate')
      || sortField === 'firstClose'
      || sortField === 'secondClose'
      || sortField === 'fundOpens';

    if (isDateField) {
      aValue = parseDateSortValue(aValue);
      bValue = parseDateSortValue(bValue);

      if (aValue === null && bValue === null) {
        return 0;
      }
      if (aValue === null) {
        return sortOrder === 'asc' ? 1 : -1;
      }
      if (bValue === null) {
        return sortOrder === 'asc' ? -1 : 1;
      }
    }
    
    if (typeof aValue === 'string' && typeof bValue === 'string') {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }
    
    if (aValue < bValue) {
      return sortOrder === 'asc' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortOrder === 'asc' ? 1 : -1;
    }
    
    if (sortField !== 'fundFamilyName') {
      const aFamily = a.fundFamilyName?.toLowerCase();
      const bFamily = b.fundFamilyName?.toLowerCase();
      if (aFamily !== bFamily) {
        return aFamily < bFamily ? -1 : 1;
      }
    }
    
    return 0;
  });
  
  return sorted;
};

export const filterData = (data, fundTypeFilter, fundFamilyFilter) => {
  return data.filter((row) => {
    const matchesType = fundTypeFilter === 'All Types' || row.type === fundTypeFilter;
    const matchesFamily = fundFamilyFilter === 'All Funds' || row.fundFamilyName === fundFamilyFilter;
    
    return matchesType && matchesFamily;
  });
};

export const getUniqueFundTypes = (data) => {
  const types = new Set();
  data.forEach((row) => {
    types.add(row.type);
  });
  return Array.from(types).sort();
};

export const getUniqueFundFamilies = (data) => {
  const families = new Set();
  data.forEach((row) => {
    families.add(row.fundFamilyName);
  });
  return Array.from(families).sort();
};
